import {TranslationKeyTransaction} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_TRANSACTION_ID: TranslationResource<TranslationKeyTransaction> = {
  translation: {
    'transaction:buttonOpenCollection': 'Buka Koleksi',
    'transaction:cancelTransactionModalMessage':
      'Kamu yakin ingin membatalkan transaksi ini?',
    'transaction:cartDoubleBookedDescription':
      'Selesaikan pembayaran, atau periksa riwayat transaksi.',
    'transaction:cartDoubleBookedTitle': 'Konten Sudah Dipesan',
    'transaction:checkTransaction': 'Cek Transaksi',
    'transaction:checkoutContentCollabRepost':
      'Collab Repost • Username kamu akan ditampilkan.',
    'transaction:checkoutContentPrice': 'Harga',
    'transaction:checkoutContentRepost':
      'Repost di beranda, fototree, profil akun.',
    'transaction:checkoutContentServiceFee': 'Biaya Layanan',
    'transaction:checkoutContentTeenNotice':
      'Posting ulang tidak diizinkan untuk akun remaja.',
    'transaction:checkoutTransactionDate': 'Tanggal Transaksi',
    'transaction:checkoutTransactionTitle': 'Detail Transaksi',
    'transaction:checkoutTransactionType': 'Tipe Transaksi',
    'transaction:checkoutWaitForHiresInfoDesc':
      'Hi-Res akan muncul di <b>“Koleksi”</b> di tab <b>“FotoYu”</b>.',
    'transaction:checkoutWaitForHiresInfoDesc_1':
      'Kamu juga dapat mengobrol dengan kreator penjual, dengan mengklik ikon pesan di bawah setiap konten yang kamu beli.',
    'transaction:checkoutWaitForHiresInfoDesc_2':
      'Kreator harus mengirimkan Hi-Res dalam 48 jam, atau kamu akan menerima pengembalian dana.',
    'transaction:checkoutWaitForHiresInfoDescPackage':
      'Buka tab <b>"FotoYu"</b> dan pilih <b>"Paket Aktif".</b>',
    'transaction:checkoutWaitForHiresInfoDescPackage_1':
      'Lakukan checkout sekali lagi untuk mengklaim momenmu. Harganya otomatis <b>Rp0.</b>',
    'transaction:checkoutWaitForHiresInfoDescPackage_2':
      'Paket ini punya batas waktu klaim. Jika masa aktifnya habis, kamu tidak bisa mengklaimnya lagi.',
    'transaction:checkoutWaitForHiresInfoTitle': 'Mohon tunggu versi Hi-Res.',
    'transaction:checkoutWaitForHiresInfoTitle_package':
      'Klaim Isi Paketmu di aplikasi mobile FotoYu',
    'transaction:checkoutUseAnotherBrowser':
      'Jika ada masalah, coba gunakan browser lain.',
    'transaction:creditCardLastFour': '(******{{number}})',
    'transaction:paymentFailedModalMessage':
      'Pembayaran tidak dapat diproses saat ini, silakan coba lagi nanti',
    'transaction:paymentIssue': 'Pembayaran bermasalah?',
    'transaction:qrisDownloadSuccess': 'QRIS diunduh.',
    'transaction:qrisInstructionContentA': '1. Unduh kode QRIS.',
    'transaction:qrisInstructionContentB':
      '2. Buka aplikasi bank / e-wallet yang mendukung pembayaran QRIS.',
    'transaction:qrisInstructionContentC':
      '3. Pindai / unggah kode QRIS yang telah diunduh.',
    'transaction:qrisInstructionContentD':
      '4. Pastikan bahwa semua informasi pembayaran sudah sesuai.',
    'transaction:qrisInstructionContentE':
      '5. Lanjutkan proses pembayaran sampai selesai.',
    'transaction:qrisInstructionTitle': 'Instruksi Pembayaran:',
    'transaction:qrisSubheader': 'Halaman ini bukan bukti pembayaran.',
    'transaction:repeatOrder': 'Ulangi Pemesanan',
  },
}
